export const DEALERSHIP_ROLE_LABELS = Object.freeze({
  manager: "Service Manager",
  dispatcher: "Dispatcher",
  advisor: "Service Advisor",
  tech: "Technician",
  technician: "Technician",
  foreman: "Shop Foreman",
  parts: "Parts Manager",
  staff: "Parts Advisor",
  admin: "Store Administrator",
});

export const PLATFORM_EMPLOYMENT_ROLE_LABELS = Object.freeze({
  super_admin: "Super Admin",
  admin: "Admin",
  support: "Support",
});

export const DEALERSHIP_ROLE_OPTIONS = Object.freeze([
  { value: "manager", label: DEALERSHIP_ROLE_LABELS.manager },
  { value: "dispatcher", label: DEALERSHIP_ROLE_LABELS.dispatcher },
  { value: "advisor", label: DEALERSHIP_ROLE_LABELS.advisor },
  { value: "tech", label: DEALERSHIP_ROLE_LABELS.tech },
  { value: "foreman", label: DEALERSHIP_ROLE_LABELS.foreman },
  { value: "parts", label: DEALERSHIP_ROLE_LABELS.parts },
  { value: "staff", label: DEALERSHIP_ROLE_LABELS.staff },
  { value: "admin", label: DEALERSHIP_ROLE_LABELS.admin },
]);

export const PLATFORM_EMPLOYMENT_ROLE_OPTIONS = Object.freeze([
  { value: "super_admin", label: PLATFORM_EMPLOYMENT_ROLE_LABELS.super_admin },
  { value: "admin", label: PLATFORM_EMPLOYMENT_ROLE_LABELS.admin },
  { value: "support", label: PLATFORM_EMPLOYMENT_ROLE_LABELS.support },
]);

export function normalizeRoleKey(value) {
  return String(value || "")
    .trim()
    .toLowerCase()
    .replace(/[_\s-]+/g, "_");
}

export function formatFallbackRoleLabel(value) {
  const key = normalizeRoleKey(value);
  if (!key) return "";
  return key
    .split("_")
    .filter(Boolean)
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(" ");
}

export function dealershipRoleLabel(value) {
  const key = normalizeRoleKey(value);
  return DEALERSHIP_ROLE_LABELS[key] || formatFallbackRoleLabel(value);
}

export function platformEmploymentRoleLabel(value) {
  const key = normalizeRoleKey(value);
  return PLATFORM_EMPLOYMENT_ROLE_LABELS[key] || dealershipRoleLabel(value);
}

export function isPlatformBusinessUnit(bu) {
  return String(bu?.storeName || "")
    .trim()
    .toLowerCase() === "platform";
}

export function employmentRoleOptionsForBusinessUnit(bu) {
  return isPlatformBusinessUnit(bu)
    ? PLATFORM_EMPLOYMENT_ROLE_OPTIONS
    : DEALERSHIP_ROLE_OPTIONS;
}

export function employmentRoleLabel(value, bu) {
  return isPlatformBusinessUnit(bu)
    ? platformEmploymentRoleLabel(value)
    : dealershipRoleLabel(value);
}
